<template>
    <div v-if="view.id && table.id" :key="table.id + '-' + view.id" class="w-100">
        <view-renderer :table="table" :view="view" :show-header="showHeader"></view-renderer>
    </div>
</template>

<script>
    import ViewService from "../services/ViewService";
    import ViewRenderer from "./renderers/ViewRenderer.vue";

    export default {
        name: 'ViewWrapper',
        components: {ViewRenderer},
        props: {
            viewId: String,
            showHeader: {
                type: Boolean,
                default: true
            }
        },
        data () {
            return {
                model: webase.model,
                service: new ViewService(),
                view: {
                    id: null,
                    name: '',
                    view_type: ''
                },
                table: {
                    id: null,
                    name: ''
                }
            }
        },
        mounted () {
            this.service.get(this.viewId).then((response) => {
                this.view = response
                this.table = webase.managers.app.getTable(this.view.model_id)
            }).catch((message) => {
                console.log('error loading view')
                console.log(message)
            })
        }
    }
</script>

<style>

</style>
